import { Box, Center, Spinner, Text } from '@chakra-ui/react';
import { PeOrderOperationType } from 'enums/modules/pe/peOperationType';
import PeOffersGrid from 'presentation/components/modules/pe/offersGrid/PeOffersGrid';
import PeCreateOrderCallCard from 'presentation/components/modules/pe/selfOrders/PeCreateOrderCallCard';
import SidebarRequestCard from 'presentation/components/modules/pe/shared/SidebarRequestCard';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import ActivesPageLayout from 'presentation/layout/modules/actives/ActivesPageLayout';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import { useFetchPeOffersV2Query } from 'rtkQuery/sharespro/queries/peService';

const PeOffersPage: FC = () => {
  const { t } = useTranslation();

  const { data, error, refetch, isFetching } = useFetchPeOffersV2Query();

  const navigate = useNavigate();

  let content;
  let wrapByCard = true;
  if (data) {
    if (
      data.companies.length > 0 ||
      data.investorsOffers.length > 0 ||
      data.sharesproOffers.length > 0
    ) {
      wrapByCard = false;
      content = (
        <>
          {data.sharesproOffers.length > 0 && (
            <>
              <GridHeading>{t('sharesproOffers')}</GridHeading>
              <PeOffersGrid
                offers={data.sharesproOffers}
                onCardClick={(offer) =>
                  navigate(AppRoute.peCompanyOrderDetail(offer.id))
                }
                onActionClick={(offer) =>
                  navigate(
                    AppRoute.createPeCompanyOrder(offer.company.id, {
                      company_name: offer.company.name,
                      operation_type: PeOrderOperationType.Buy,
                      company_currency: offer.company.currency.symbol,
                    })
                  )
                }
              />
            </>
          )}
          <Box mb="20px"><PeCreateOrderCallCard /></Box>
          {data.investorsOffers.length > 0 && (
            <>
              <GridHeading>{t('p2pOffers')}</GridHeading>
              <PeOffersGrid
                offers={data.investorsOffers}
                onCardClick={(offer) =>
                  navigate(AppRoute.peP2POrderDetail(offer.id))
                }
                onActionClick={(offer) =>
                  navigate(AppRoute.peP2POrderDetail(offer.id))
                }
              />
            </>
          )}
          {data.companies.length > 0 && (
            <>
              <GridHeading>{t('companies')}</GridHeading>
              <PeOffersGrid
                offers={data.companies}
                onCardClick={(offer) =>
                  navigate(AppRoute.peCompanyDetail(offer.id))
                }
                onActionClick={(offer) =>
                  navigate(AppRoute.peCompanyDetail(offer.id))
                }
              />
            </>
          )}
        </>
      );
    } else {
      content = <Text>{t('listIsEmpty')}</Text>;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  if (wrapByCard) {
    content = (
      <>
        <GridHeading>{t('peOffers')}</GridHeading>
        <AppCard mb="20px" p="20px">
          <Center>{content}</Center>
        </AppCard>
      </>
    );
  }

  return (
    <ActivesPageLayout sidebarContent={<SidebarRequestCard />}>
      <Helmet>
        <title>{t('peOffers')}</title>
      </Helmet>
      {content}
    </ActivesPageLayout>
  );
};

export default PeOffersPage;
